import { Routes } from '@angular/router';

import { WorkflowStepsData } from '../shared/components/workflow-steps/workflow-steps.component';
import { SERVICE_ANALYTICS } from '../shared/models/list';

import { OrganizationCardComponent } from './components/organization-card/organization-card.component';
import {
	OrganizationCardTransactionalVisibilitiesComponent
} from './components/organization-card/self/organization-card-transactional-visibilities.component';
import {
	OrganizationCardInformationalVisibilitiesComponent
} from './components/organization-card/self/organization-card-informational-visibilities.component';
import { organizationGuard } from './guards/organization.guard';
import { UserCardComponent } from './components/user-card/user-card.component';
import { UserCardSettingsComponent } from './components/user-card/self/user-self-card-settings.component';
import { UserCardServiceComponent } from './components/user-card/self/user-self-card-service.component';
import {
	OrganizationCardDetailsComponent
} from './components/organization-card/self/organization-card-details.component';
import {
	OrganizationCardServicesComponent
} from './components/organization-card/self/organization-card-services.component';
import { UserCardNotificationComponent } from './components/user-card/self/user-self-card-notification.component';
import { OrganizationCardUsersComponent } from './components/organization-card/self/organization-card-users.component';
import { UserCardPrivacySettingsComponent }
	from './components/user-card/self/user-self-card-privacy-settings.component';
import { UserCardSecurityComponent } from './components/user-card/self/user-self-card-security.component';
import { UserManageServicesComponent } from './components/user-card/self/user-manage-services.component';
import {
	AddUserToOrganizationComponent
} from './components/organization-card/self/add/add-user/add-user-to-organization.component';
import {
	StepUserInfoComponent
}
	from './components/organization-card/self/add/add-user/step-user-info/step-user-info.component';
import {
	StepMatchingUsersComponent
} from './components/organization-card/self/add/add-user/step-matching-users/step-matching-users.component';
import {
	StepServicesManagementComponent
} from './components/organization-card/self/add/add-user/step-services-management/step-services-management.component';
import {
	StepConfirmationComponent
} from './components/organization-card/self/add/add-user/step-confirmation/step-confirmation.component';
import { OrganizationManageServicesComponent }
	from './components/organization-card/self/organization-manage-services.component';
import {
	AddSubOrganizationComponent
} from './components/organization-card/self/add/add-suborg/add-sub-organization.component';
import {
	StepOrganizationDetailsComponent
// eslint-disable-next-line @stylistic/max-len
} from './components/organization-card/self/add/add-suborg/step-organization-details/step-organization-details.component';
import {
	StepMatchingOrganizationsComponent
// eslint-disable-next-line @stylistic/max-len
} from './components/organization-card/self/add/add-suborg/step-matching-organizations/step-matching-organizations.component';
import {
	StepChooseAdministartorComponent
// eslint-disable-next-line @stylistic/max-len
} from './components/organization-card/self/add/add-suborg/step-choose-administrator/step-choose-administrator.component';
import {
	StepConfirmSubOrgComponent
} from './components/organization-card/self/add/add-suborg/step-confirm-suborg/step-confirm-suborg.component';
import { userResolver } from './resolvers/user.resolver';

const ADD_USER_STEPS_DATA: WorkflowStepsData = {
	// eslint-disable-next-line unicorn/no-unused-properties
	afterSubmitUrl: '/users',
	steps: [
		{
			labelTranslationKey: 'add-user.user-informations',
			path: 'stepUserInfo'
		},
		{
			labelTranslationKey: 'add-user.matching-users',
			path: 'stepMatchingUsers'
		},
		{
			labelTranslationKey: 'add-user.service-management',
			path: 'stepServiceManagement'
		},
		{
			labelTranslationKey: 'add-user.confirmation',
			path: 'stepConfirmation'
		}
	],
};

const ADD_SUBORG_STEPS_DATA: WorkflowStepsData = {
	// eslint-disable-next-line unicorn/no-unused-properties
	afterSubmitUrl: '/details',
	steps: [
		{
			labelTranslationKey: 'add-suborg.organization-details',
			path: 'stepOrganizationDetails'
		},
		{
			labelTranslationKey: 'add-suborg.matching-organizations',
			path: 'stepMatchingOrganizations'
		},
		{
			labelTranslationKey: 'add-suborg.administrator',
			path: 'stepChooseAdministrator'
		},
		{
			labelTranslationKey: 'add-suborg.confirmation',
			path: 'stepConfirmation'
		}
	],
};

export const routes: Routes = [
	{
		path: '',
		children: [
			{
				path: '',
				pathMatch: 'full',
				redirectTo: 'card/self/settings/general',
				data: { pageName: 'Redirect', service: SERVICE_ANALYTICS.USER }
			},
			{
				path: 'card/self',
				component: UserCardComponent,
				resolve: {
					user: userResolver
				},
				/* header with buttons only */
				data: { pageName: 'Users - Header', service: SERVICE_ANALYTICS.USER },
				children: [
					{
						path: 'settings',
						children: [
							{
								path: '',
								redirectTo: 'general',
								pathMatch: 'full',
								data: { pageName: 'Redirect', service: SERVICE_ANALYTICS.USER }
							},
							{
								path: 'general',
								component: UserCardSettingsComponent,
								data: { pageName: 'Users - User Details Self', service: SERVICE_ANALYTICS.USER }
							}
						]
					},
					{
						path: 'service',
						component: UserCardServiceComponent,
						data: { pageName: 'Users - User Services Self', service: SERVICE_ANALYTICS.USER }
					},
					{
						path: 'notification',
						component: UserCardNotificationComponent,
						data: { pageName: 'Users - User Notifications Self', service: SERVICE_ANALYTICS.USER }
					},
					{
						path: 'security',
						component: UserCardSecurityComponent,
						data: { pageName: 'Users - User Security Self', service: SERVICE_ANALYTICS.USER }
					},
					{
						path: 'privacy-setting',
						component: UserCardPrivacySettingsComponent,
						data: { pageName: 'Users - Privacy Settings Self', service: SERVICE_ANALYTICS.USER }
					}
				]
			},
			{
				path: 'card/:id',
				component: UserCardComponent,
				resolve: {
					user: userResolver
				},
				/* header with buttons only */
				data: { pageName: 'Users - User Header', service: SERVICE_ANALYTICS.USER },
				children: [
					{
						path: 'settings',
						children: [
							{
								path: '',
								redirectTo: 'general',
								pathMatch: 'full',
								data: { pageName: 'Redirect' }
							},
							{
								path: 'general',
								component: UserCardSettingsComponent,
								data: { pageName: 'Users - User Details', service: SERVICE_ANALYTICS.USER }
							},
						]
					},
					{
						path: 'service',
						component: UserCardServiceComponent,
						data: { pageName: 'Users - User Services', service: SERVICE_ANALYTICS.USER }
					},
					{
						path: 'manage-service/:memberId',
						component: UserManageServicesComponent,
						data: { pageName: 'Users - User Services Mangement', service: SERVICE_ANALYTICS.USER }
					},
					{
						path: 'notification',
						component: UserCardNotificationComponent,
						data: { pageName: 'Users - User Notifications', service: SERVICE_ANALYTICS.USER }
					},
					{
						path: 'privacy-setting',
						component: UserCardPrivacySettingsComponent,
						data: { pageName: 'Users - Privacy Settings', service: SERVICE_ANALYTICS.USER }
					}
				]
			},
			{
				path: 'organization/:id',
				canActivate: [organizationGuard],
				component: OrganizationCardComponent,
				/* header with buttons only */
				data: { pageName: 'Organizations -Organization Header', service: SERVICE_ANALYTICS.USER },
				children: [
					{
						path: 'details',
						component: OrganizationCardDetailsComponent,
						data: { pageName: 'Organization Details', service: SERVICE_ANALYTICS.USER }
					},
					{
						path: 'details/addSubOrg',
						component: AddSubOrganizationComponent,
						children: [
							{
								path: '',
								redirectTo: ADD_SUBORG_STEPS_DATA.steps[0].path,
								pathMatch: 'full',
								data: { pageName: 'Redirect', service: SERVICE_ANALYTICS.USER }
							},
							{
								path: ADD_SUBORG_STEPS_DATA.steps[0].path,
								component: StepOrganizationDetailsComponent,
								data: { pageName: 'Add SubOrg - Org Details', service: SERVICE_ANALYTICS.USER }
							},
							{
								path: ADD_SUBORG_STEPS_DATA.steps[1].path,
								component: StepMatchingOrganizationsComponent,
								data: { pageName: 'Add SubOrg - Matching Org', service: SERVICE_ANALYTICS.USER }
							},
							{
								path: ADD_SUBORG_STEPS_DATA.steps[2].path,
								component: StepChooseAdministartorComponent,
								data: { pageName: 'Add SubOrg - Choose Admin', service: SERVICE_ANALYTICS.USER }
							},
							{
								path: ADD_SUBORG_STEPS_DATA.steps[3].path,
								component: StepConfirmSubOrgComponent,
								data: { pageName: 'Add SubOrg - Summary', service: SERVICE_ANALYTICS.USER }
							}
						],
					},
					{
						path: 'informational-visibilities',
						component: OrganizationCardInformationalVisibilitiesComponent,
						data: { pageName: 'Organizatio Informational Visibilities',
							service: SERVICE_ANALYTICS.USER },
					},
					{
						path: 'transactional-visibilities',
						component: OrganizationCardTransactionalVisibilitiesComponent,
						data: { pageName: 'Organization Transactional Visibilities',
							service: SERVICE_ANALYTICS.USER },
					},
					{
						path: 'services',
						component: OrganizationCardServicesComponent,
						data: { pageName: 'Organization Services', service: SERVICE_ANALYTICS.USER }
					},
					{
						path: 'manage-service',
						component: OrganizationManageServicesComponent,
						data: { pageName: 'Organization Services Mangement', service: SERVICE_ANALYTICS.USER }
					},
					{
						path: 'users',
						component: OrganizationCardUsersComponent,
						data: { pageName: 'Organization Users', service: SERVICE_ANALYTICS.USER }
					},
					{
						path: 'users/add',
						component: AddUserToOrganizationComponent,
						children: [
							{
								path: '',
								redirectTo: ADD_USER_STEPS_DATA.steps[0].path,
								pathMatch: 'full',
								data: { pageName: 'Redirect', service: SERVICE_ANALYTICS.USER }
							},
							{
								path: ADD_USER_STEPS_DATA.steps[0].path,
								component: StepUserInfoComponent,
								data: { pageName: 'Add User - User Info', service: SERVICE_ANALYTICS.USER }
							},
							{
								path: ADD_USER_STEPS_DATA.steps[1].path,
								component: StepMatchingUsersComponent,
								data: { pageName: 'Add User - Matching users', service: SERVICE_ANALYTICS.USER }
							},
							{
								path: ADD_USER_STEPS_DATA.steps[2].path,
								component: StepServicesManagementComponent,
								data: { pageName: 'Add User - Service Management', service: SERVICE_ANALYTICS.USER }
							},
							{
								path: ADD_USER_STEPS_DATA.steps[3].path,
								component: StepConfirmationComponent,
								data: { pageName: 'Add User - Confirmation', service: SERVICE_ANALYTICS.USER }
							}
						],
					},
				]
			}
		]
	}
];
